import { ModalM } from "@common/components/modal/ModalM"
import PdfViewer from "@common/components/pdf/PdfViewer"
import React from "react"
import { View } from "react-native"
import { IconButton } from "react-native-paper"
import { theme } from "../../theme/theme"

const PdfViewerModal = ({ visible, onDismiss, pdfFile }) => {
    if (!pdfFile) {
        return null
    }

    return (
        <ModalM
            visible={visible}
            onDismiss={onDismiss}
            style={{
                width: "96%",
                maxHeight: "90%",
                height: "90%",
                flex: 1,
                backgroundColor: theme.colors.black,
            }}
        >
            <View
                style={{
                    width: "100%",
                    height: 60,
                    paddingRight: 5,
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                }}
            >
                <View
                    style={{
                        flexDirection: "row",
                        alignItems: "center",
                    }}
                >
                    <IconButton
                        icon={"times"}
                        iconColor={theme.colors.white}
                        containerColor={theme.colors.transparent}
                        size={32}
                        onPress={onDismiss}
                    />
                </View>
            </View>
            <PdfViewer file={pdfFile.uri} footer={false} noModal={false} />
        </ModalM>
    )
}

export default PdfViewerModal
